import React, { useEffect, useState, useContext} from 'react'
import '../../styles/MyEventsUI.css';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../UserContext';
import Grid from '@mui/material/Grid';
import { useNavigate } from "react-router-dom";
import EventsPopUI from './EventsPopUI';
import TrophiesAndCountMob from '../MobUI/TrophiesAndCountMob';

const MyEventsUI = () => {

const {user} = useContext(UserContext)
const [openEvents,setOpenEvents] = useState(false);
const [events,setEvents] = useState([]);

useEffect(()=>{
	if(user){
		getEvents()
	}
	
},[user])



//get comunity
const getEvents = ()=>{
	
    let apiURL=process.env.REACT_APP_API_URL + "/events/getallevents"; 

    fetch(apiURL)
    .then((res)=> (res.status===200 ? res.json() : res.text()))
    .then((repos)=> {
        if (repos.data) {
         
          setEvents(repos.data);
        }else alert(repos.message || repos);  
    }) 
    .catch((err) => alert(err));
  }

  
 

  return (
    <div>
      <div id="add_events_PC" onClick={()=>setOpenEvents(true)}>
		<div id="Add_events_PC_new_events_page_">
			<span>Add Events</span>
		</div>
		<img id="add_events_PC_y" src="./MyPortfolio/Events/add_events_PC_y.png" srcset="./MyPortfolio/Events/add_events_PC_y.png 1x" />
			
	</div>
	<div id="card_grp_event_page_pc">

		<div id="recent_events_all_grp_pc">
			<svg class="recent_events_new_events_page__">
				<linearGradient id="recent_events_new_events_page__" spreadMethod="pad" x1="1.142" x2="0.009" y1="1.187" y2="0">
					<stop offset="0" stop-color="#40e196" stop-opacity="1"></stop>
					<stop offset="1" stop-color="#fff" stop-opacity="1"></stop>
				</linearGradient>
				<rect id="recent_events_new_events_page__" rx="20" ry="20" x="0" y="0" width="100%" height="556">
				</rect>
			</svg>
			<svg class="recent_events_line_new_events_pc" viewBox="0 0 5 26">
				<path id="recent_events_line_new_events_pc" d="M 0 0 L 0 26">
				</path>
			</svg>
			<div id="recent_events_new_events_page__ba">
				<span>Recent Events</span>
			</div>
			<div id="Scroll_recent_events">
			{events.filter(rec=>rec.organiserId===user._id).map((eve)=>(
				<div id="recent_event_card_1_event_new_">
					<svg class="all_card_borer_v">
						<rect id="all_card_borer_v" rx="10" ry="10" x="0" y="0" width="326.76" height="445">
						</rect>
					</svg>
					<div id="By_by_vent_new_pc">
						<span>By</span>
					</div>
					<div id="Son_Goku_lbl_my_anme">
						<span>{eve.organiserName}</span>
					</div>
					<div id="Comic_Con_Bangalore_-_2023_ven">
						<span>{eve.title}</span>
					</div>
					<img id="img_logo_vent_new_pc" src={eve.organiserImageId?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.organiserImageId:"./MyPortfolio/Events/img_logo_vent_new_pc.png"} />
						
					<img id="idk_vent_new_pc" src={eve.eventImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.eventImageUrl.split('/')[5]:"./MyPortfolio/Events/idk_vent_new_pc.png"}  />
						
					<svg class="img_bdr_vent_new_pc">
						<rect id="img_bdr_vent_new_pc" rx="8" ry="8" x="0" y="0" width="287" height="159">
						</rect>
					</svg>

					<div id="seats_grp_event_pc">
						<div id="Seats_lbl_vent_new_pc">
							<span>Seats</span>
						</div>
						<div id="n_0_lbl_vent_new_pc">
							<span>50%</span>
						</div>
						<svg class="seats_all_bar_vent_new_pc">
							<rect id="seats_all_bar_vent_new_pc" rx="2" ry="2" x="0" y="0" width="256" height="4">
							</rect>
						</svg>
						<svg class="seats_bar_1_vent_new_pc">
							<rect id="seats_bar_1_vent_new_pc" rx="2" ry="2" x="0" y="0" width="130" height="4">
							</rect>
						</svg>
					</div>
					{/* <svg class="bdr_paid_vent_new_pc">
						<rect id="bdr_paid_vent_new_pc" rx="5" ry="5" x="0" y="0" width="55" height="31">
						</rect>
					</svg> */}
					{/* <div id="Paid_lbl_vent_new_pc">
						<span>Paid</span>
					</div> */}
					<svg class="amount_bdr_vent_new_pc">
						<rect id="amount_bdr_vent_new_pc" rx="5" ry="5" x="0" y="0" width="73" height="31">
						</rect>
					</svg>
					<div id="n_1139_vent_new_pc">
						<span>{eve.cost}</span>
					</div>
					
					{/* <svg class="signal_event_new_pc">
						<ellipse id="signal_event_new_pc" rx="3.096630334854126" ry="3.096630334854126" cx="3.096630334854126" cy="3.096630334854126">
						</ellipse>
					</svg>
					<div id="Online_Event_lbl_event_new_pc">
						<span>2hrs To Go</span>
					</div> */}

					{/* <img id="trophy_img_event_new_pc" src="./MyPortfolio/Events/trophy_img_event_new_pc.png" srcset="./MyPortfolio/Events/trophy_img_event_new_pc.png 1x" />
						
					<div id="n_234_com_event_new_pc">
						<span>1234</span>
					</div> */}
					<svg class="bdr_trophie_v">
						<rect id="bdr_trophie_v" rx="5" ry="5" x="0" y="0" width="73" height="31">
						</rect>
					</svg>
					<div id='trophy_img_event_new_pc'>
					<TrophiesAndCountMob portfolioType={"events"} portfolioId={eve._id} />
					</div>
					
					<svg class="share_bdrevent_new_pc_reent_ev">
						<ellipse id="share_bdrevent_new_pc_reent_ev" rx="19" ry="19" cx="19" cy="19">
						</ellipse>
					</svg>
					<img id="share_event_new_pc" src="./MyPortfolio/Events/share_event_new_pc.png" srcset="./MyPortfolio/Events/share_event_new_pc.png 1x" />
						
					<div id="from_to_grp_pc_event">
						<div id="From_pc_event">
							<span>From</span>
						</div>
						<div id="n_3th_Jan_2023_vent_pc_event">
							<span>{eve.startsOn.slice(0,10)} - {eve.startsOn.slice(11,16)} IST</span>
						</div>
						<svg class="cal_64_pc_event">
							<ellipse id="cal_64_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_8h_pc_event">
							<ellipse id="cal_8h_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_87_pc_event">
							<ellipse id="cal_87_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_57_pc_event">
							<ellipse id="cal_57_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_r54_pc_event">
							<ellipse id="cal_r54_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_ourter_pc_event">
							<ellipse id="cal_ourter_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_6_pc_event" viewBox="0 0 17 17">
							<path id="cal_6_pc_event" d="M 16.3359375 11.6875 C 16.70269966125488 11.6875 17 11.39019870758057 17 11.0234375 L 17 3.984375238418579 C 17 2.519718647003174 15.80840587615967 1.328125 14.34375 1.328125 L 13.48046875 1.328125 L 13.48046875 0.6640625 C 13.48046875 0.297300785779953 13.18316745758057 0 12.81640625 0 C 12.44964504241943 0 12.15234375 0.297300785779953 12.15234375 0.6640625 L 12.15234375 1.328125 L 9.130859375 1.328125 L 9.130859375 0.6640625 C 9.130859375 0.297300785779953 8.833558082580566 0 8.466796875 0 C 8.100035667419434 0 7.802734851837158 0.297300785779953 7.802734851837158 0.6640625 L 7.802734851837158 1.328125 L 4.814453125 1.328125 L 4.814453125 0.6640625 C 4.814453125 0.297300785779953 4.517152309417725 0 4.150390625 0 C 3.783628702163696 0 3.486328125 0.297300785779953 3.486328125 0.6640625 L 3.486328125 1.328125 L 2.65625 1.328125 C 1.191593766212463 1.328125 0 2.519718647003174 0 3.984375238418579 L 0 14.34375 C 0 15.80840587615967 1.191593766212463 17 2.65625 17 L 14.34375 17 C 15.80840587615967 17 17 15.80840587615967 17 14.34375 C 17 13.97698879241943 16.70269966125488 13.6796875 16.3359375 13.6796875 C 15.96917629241943 13.6796875 15.67187595367432 13.97698879241943 15.67187595367432 14.34375 C 15.67187595367432 15.07607841491699 15.07607841491699 15.67187595367432 14.34375 15.67187595367432 L 2.65625 15.67187595367432 C 1.923921704292297 15.67187595367432 1.328125 15.07607841491699 1.328125 14.34375 L 1.328125 3.984375238418579 C 1.328125 3.252046585083008 1.923921704292297 2.65625 2.65625 2.65625 L 3.486328125 2.65625 L 3.486328125 3.3203125 C 3.486328125 3.687074184417725 3.783628702163696 3.984375238418579 4.150390625 3.984375238418579 C 4.517151832580566 3.984375238418579 4.814453125 3.687074184417725 4.814453125 3.3203125 L 4.814453125 2.65625 L 7.802734851837158 2.65625 L 7.802734851837158 3.3203125 C 7.802734851837158 3.687074184417725 8.100034713745117 3.984375238418579 8.466796875 3.984375238418579 C 8.833558082580566 3.984375238418579 9.130859375 3.687074184417725 9.130859375 3.3203125 L 9.130859375 2.65625 L 12.15234375 2.65625 L 12.15234375 3.3203125 C 12.15234375 3.687074184417725 12.44964504241943 3.984375238418579 12.81640625 3.984375238418579 C 13.18316745758057 3.984375238418579 13.48046875 3.687074184417725 13.48046875 3.3203125 L 13.48046875 2.65625 L 14.34375 2.65625 C 15.07607841491699 2.65625 15.67187595367432 3.252046585083008 15.67187595367432 3.984375238418579 L 15.67187595367432 11.0234375 C 15.67187595367432 11.39019870758057 15.96917629241943 11.6875 16.3359375 11.6875 Z">
							</path>
						</svg>
						<svg class="cal_6_pc_event_b">
							<ellipse id="cal_6_pc_event_b" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_5_e_pc_event">
							<ellipse id="cal_5_e_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_pc_event">
							<ellipse id="cal_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_3_pc_event">
							<ellipse id="cal_3_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_2_pc_event">
							<ellipse id="cal_2_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="cal_1_pc_event">
							<ellipse id="cal_1_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<div id="To_lbl_pc_event">
							<span>To</span>
						</div>
						<div id="date_pc_event">
							<span>{eve.endsOn.slice(0,10)} - {eve.endsOn.slice(11,16)} IST</span>
						</div>
					</div>
					<div id="location_grp_pc_event">
						<div id="Location_lbl_pc_event_pc">
							<span>Location</span>
						</div>
						<div id="Online_Meet_-_up_lbl_pc_event_">
							<span>{eve.location}</span>
						</div>
						<svg class="outer_loca_pc_event_pc" viewBox="48.886 0 13.754 17">
							<path id="outer_loca_pc_event_pc" d="M 61.4056282043457 2.955788135528564 C 60.10781478881836 1.077479243278503 58.05097198486328 0 55.76290130615234 0 C 53.47483062744141 0 51.41798782348633 1.077479243278503 50.12017440795898 2.955788135528564 C 48.82873153686523 4.824601173400879 48.53053283691406 7.190566539764404 49.32090377807617 9.280878067016602 C 49.53231048583984 9.851707458496094 49.86835861206055 10.4063024520874 50.31733703613281 10.92599868774414 L 55.31037902832031 16.79082679748535 C 55.42330169677734 16.92357063293457 55.58875274658203 17.00007247924805 55.76290130615234 17.00007247924805 C 55.93705749511719 17.00007247924805 56.10250473022461 16.92360496520996 56.21543121337891 16.79082679748535 L 61.20707321166992 10.92759323120117 C 61.65804290771484 10.4049072265625 61.9936637878418 9.850911140441895 62.20330810546875 9.284663200378418 C 62.99526977539062 7.19056510925293 62.69707107543945 4.824600696563721 61.4056282043457 2.955788135528564 Z M 61.0901985168457 8.868359565734863 C 60.92852783203125 9.305248260498047 60.66459655761719 9.737189292907715 60.30617141723633 10.15266227722168 C 60.30517578125 10.15365791320801 60.30417633056641 10.15465450286865 60.30338287353516 10.15584945678711 L 55.76290130615234 15.48889255523682 L 51.21963119506836 10.15249729156494 C 50.86140441894531 9.73738956451416 50.59746932983398 9.30548095703125 50.4342041015625 8.864409446716309 C 49.78056716918945 7.135680675506592 50.02863311767578 5.179476737976074 51.09797668457031 3.631839990615845 C 52.17067337036133 2.079255342483521 53.87107849121094 1.188809871673584 55.76290130615234 1.188809871673584 C 57.65469360351562 1.188809871673584 59.35490036010742 2.079221963882446 60.42762756347656 3.631839990615845 C 61.49717330932617 5.179476737976074 61.74543380737305 7.135680675506592 61.0901985168457 8.868359565734863 Z">
							</path>
						</svg>
						<svg class="loaction_img_pc_event_pc" viewBox="155.754 106.219 6.657 6.657">
							<path id="loaction_img_pc_event_pc" d="M 159.0827178955078 106.218994140625 C 157.2473754882812 106.218994140625 155.7540283203125 107.712158203125 155.7540283203125 109.5476989746094 C 155.7540283203125 111.3832397460938 157.2471923828125 112.8763885498047 159.0827178955078 112.8763885498047 C 160.9182739257812 112.8763885498047 162.4114074707031 111.3832397460938 162.4114074707031 109.5476989746094 C 162.4114074707031 107.7123565673828 160.9180603027344 106.218994140625 159.0827178955078 106.218994140625 Z M 159.0827178955078 111.6875457763672 C 157.9028167724609 111.6875457763672 156.9428405761719 110.7275695800781 156.9428405761719 109.5476684570312 C 156.9428405761719 108.3677520751953 157.9028167724609 107.4077758789062 159.0827178955078 107.4077758789062 C 160.2626342773438 107.4077758789062 161.2225952148438 108.3677520751953 161.2225952148438 109.5476684570312 C 161.2225952148438 110.7275695800781 160.2626342773438 111.6875457763672 159.0827178955078 111.6875457763672 Z">
							</path>
						</svg>
					</div>
				</div>
				))}
			</div>
		</div>

		
		<div id="red_trendding_grp_">
			<svg class="trending_events_bdr_new_events_cj">
				<linearGradient id="trending_events_bdr_new_events_cj" spreadMethod="pad" x1="1.564" x2="0" y1="1.534" y2="-0.022">
					<stop offset="0" stop-color="#ff2626" stop-opacity="1"></stop>
					<stop offset="1" stop-color="#fff" stop-opacity="1"></stop>
				</linearGradient>
				<rect id="trending_events_bdr_new_events_cj" rx="20" ry="20" x="0" y="0" width="100%" height="559">
				</rect>
			</svg>
			<svg class="trwnd_line_new_events_page_pc" viewBox="0 0 5 26">
				<path id="trwnd_line_new_events_page_pc" d="M 0 0 L 0 26">
				</path>
			</svg>
			<div id="trending_new_events_page_pc">
				<span>Trending Events</span>
			</div>
			<div id="Scroll_trending_events">
			{events.filter(rec=>rec.organiserId===user._id).map((eve)=>(
				<div id="trending_card_grp_event_new_pc">
					<svg class="card_1_bdr_event_new_pc">
						<rect id="card_1_bdr_event_new_pc" rx="10" ry="10" x="0" y="0" width="326.76" height="448">
						</rect>
					</svg>
					<div id="By_event_new_pc">
						<span>By</span>
					</div>
					<div id="Son_Goku_event_new_pc">
						<span>{eve.organiserName}</span>
					</div>
					<div id="Dragon_Ball_Super_Movie_-_Rise">
						<span>{eve.title}</span>
					</div>
					<img id="logo_event_new_pc" src={eve.organiserImageId?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.organiserImageId:"./MyPortfolio/Events/logo_event_new_pc.png"} />
						
					<img id="Anime_Edit_img_event_new_pc" src={eve.eventImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.eventImageUrl.split('/')[5]:"./MyPortfolio/Events/Anime_Edit_img_event_new_pc.png"} />
						
					<svg class="bdr_img_1_event_new_pc">
						<rect id="bdr_img_1_event_new_pc" rx="8" ry="8" x="0" y="0" width="287" height="159">
						</rect>
					</svg>
					<div id="seats_events_page_upcoming_eve">
						<div id="Seats_event_new_pc">
							<span>Seats</span>
						</div>
						<div id="n_0_event_new_pc">
							<span>50%</span>
						</div>
						<svg class="bdr_prog_event_new_pc">
							<rect id="bdr_prog_event_new_pc" rx="2" ry="2" x="0" y="0" width="256" height="4">
							</rect>
						</svg>
						<svg class="prog_bar_event_new_pc">
							<rect id="prog_bar_event_new_pc" rx="2" ry="2" x="0" y="0" width="130" height="4">
							</rect>
						</svg>
					</div>
					{/* <svg class="bdr_event_new_pc">
						<rect id="bdr_event_new_pc" rx="5" ry="5" x="0" y="0" width="55" height="31">
						</rect>
					</svg>
					<div id="Paid_lbl_event_new_pc">
						<span>Paid</span>
					</div> */}
					<svg class="amount_bdr_event_new_pc">
						<rect id="amount_bdr_event_new_pc" rx="5" ry="5" x="0" y="0" width="73" height="31">
						</rect>
					</svg>
					<div id="n_1139_lbl_event_new_pc">
						<span>{eve.cost}</span>
					</div>
					{/* <svg class="sign_event_new_pc">
						<ellipse id="sign_event_new_pc" rx="3.096630334854126" ry="3.096630334854126" cx="3.096630334854126" cy="3.096630334854126">
						</ellipse>
					</svg>
					<div id="Online_Event_lbl_event_new_pc_c">
						<span>Online Event</span>
					</div> */}
					<svg class="share_bdr_small_event_new_pc">
						<ellipse id="share_bdr_small_event_new_pc" rx="19" ry="19" cx="19" cy="19">
						</ellipse>
					</svg>
					<img id="share_img_event_new_pc" src="./MyPortfolio/Events/share_img_event_new_pc.png" srcset="./MyPortfolio/Events/share_img_event_new_pc.png 1x" />
						
					<svg class="bdr_trophie_v_eevents">
						<rect id="bdr_trophie_v_eevents" rx="5" ry="5" x="0" y="0" width="73" height="31">
						</rect>
					</svg>
					{/* <img id="trophy_img_event_new_pc_23" src="./MyPortfolio/Events/trophy_img_event_new_pc_23.png" srcset="./MyPortfolio/Events/trophy_img_event_new_pc_23.png 1x" />  */}
						
					{/* <div id="n_234_com_event_new_pc_32">
						<span>1234</span>
					</div> */}

					<div id='trophy_img_event_new_pc_23'>
					<TrophiesAndCountMob portfolioType={"events"} portfolioId={eve._id} />
					</div>

					<div id="details_evnts_pc_event">
						<div id="From_lbl_pc_event">
							<span>From</span>
						</div>
						<div id="n_3th_Jan_2023_pc_event">
							<span>{eve.startsOn.slice(0,10)} - {eve.startsOn.slice(11,16)} IST</span>
						</div>
						<div id="To_lbl_pc_event_de">
							<span>To</span>
						</div>
						<div id="n_4th_Jan_2023_lbl_pc_event">
							<span>{eve.endsOn.slice(0,10)} - {eve.endsOn.slice(11,16)} IST</span>
						</div>
						<svg class="Ellipse_223_pc_event">
							<ellipse id="Ellipse_223_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_236_pc_event">
							<ellipse id="Ellipse_236_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_237_pc_event">
							<ellipse id="Ellipse_237_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_224_pc_event">
							<ellipse id="Ellipse_224_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_234_pc_event">
							<ellipse id="Ellipse_234_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_235_pc_event">
							<ellipse id="Ellipse_235_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Path_3483_pc_event" viewBox="0 0 17 17">
							<path id="Path_3483_pc_event" d="M 16.3359375 11.6875 C 16.70269966125488 11.6875 17 11.39019870758057 17 11.0234375 L 17 3.984375238418579 C 17 2.519718647003174 15.80840587615967 1.328125 14.34375 1.328125 L 13.48046875 1.328125 L 13.48046875 0.6640625 C 13.48046875 0.297300785779953 13.18316745758057 0 12.81640625 0 C 12.44964504241943 0 12.15234375 0.297300785779953 12.15234375 0.6640625 L 12.15234375 1.328125 L 9.130859375 1.328125 L 9.130859375 0.6640625 C 9.130859375 0.297300785779953 8.833558082580566 0 8.466796875 0 C 8.100035667419434 0 7.802734851837158 0.297300785779953 7.802734851837158 0.6640625 L 7.802734851837158 1.328125 L 4.814453125 1.328125 L 4.814453125 0.6640625 C 4.814453125 0.297300785779953 4.517152309417725 0 4.150390625 0 C 3.783628702163696 0 3.486328125 0.297300785779953 3.486328125 0.6640625 L 3.486328125 1.328125 L 2.65625 1.328125 C 1.191593766212463 1.328125 0 2.519718647003174 0 3.984375238418579 L 0 14.34375 C 0 15.80840587615967 1.191593766212463 17 2.65625 17 L 14.34375 17 C 15.80840587615967 17 17 15.80840587615967 17 14.34375 C 17 13.97698879241943 16.70269966125488 13.6796875 16.3359375 13.6796875 C 15.96917629241943 13.6796875 15.67187595367432 13.97698879241943 15.67187595367432 14.34375 C 15.67187595367432 15.07607841491699 15.07607841491699 15.67187595367432 14.34375 15.67187595367432 L 2.65625 15.67187595367432 C 1.923921704292297 15.67187595367432 1.328125 15.07607841491699 1.328125 14.34375 L 1.328125 3.984375238418579 C 1.328125 3.252046585083008 1.923921704292297 2.65625 2.65625 2.65625 L 3.486328125 2.65625 L 3.486328125 3.3203125 C 3.486328125 3.687074184417725 3.783628702163696 3.984375238418579 4.150390625 3.984375238418579 C 4.517151832580566 3.984375238418579 4.814453125 3.687074184417725 4.814453125 3.3203125 L 4.814453125 2.65625 L 7.802734851837158 2.65625 L 7.802734851837158 3.3203125 C 7.802734851837158 3.687074184417725 8.100034713745117 3.984375238418579 8.466796875 3.984375238418579 C 8.833558082580566 3.984375238418579 9.130859375 3.687074184417725 9.130859375 3.3203125 L 9.130859375 2.65625 L 12.15234375 2.65625 L 12.15234375 3.3203125 C 12.15234375 3.687074184417725 12.44964504241943 3.984375238418579 12.81640625 3.984375238418579 C 13.18316745758057 3.984375238418579 13.48046875 3.687074184417725 13.48046875 3.3203125 L 13.48046875 2.65625 L 14.34375 2.65625 C 15.07607841491699 2.65625 15.67187595367432 3.252046585083008 15.67187595367432 3.984375238418579 L 15.67187595367432 11.0234375 C 15.67187595367432 11.39019870758057 15.96917629241943 11.6875 16.3359375 11.6875 Z">
							</path>
						</svg>
						<svg class="Ellipse_226_pc_event">
							<ellipse id="Ellipse_226_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_230_pc_event">
							<ellipse id="Ellipse_230_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_231_pc_event">
							<ellipse id="Ellipse_231_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_229_pc_event">
							<ellipse id="Ellipse_229_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_232_pc_event">
							<ellipse id="Ellipse_232_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="Ellipse_233_pc_event">
							<ellipse id="Ellipse_233_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<div id="Location_lbl_pc_event">
							<span>Location</span>
						</div>
						<div id="Online_Meet_-_up_pc_event">
							<span>{eve.location}</span>
						</div>
						<svg class="location_2_pc_event" viewBox="48.886 0 13.754 17">
							<path id="location_2_pc_event" d="M 61.4056282043457 2.955788135528564 C 60.10781478881836 1.077479243278503 58.05097198486328 0 55.76290130615234 0 C 53.47483062744141 0 51.41798782348633 1.077479243278503 50.12017440795898 2.955788135528564 C 48.82873153686523 4.824601173400879 48.53053283691406 7.190566539764404 49.32090377807617 9.280878067016602 C 49.53231048583984 9.851707458496094 49.86835861206055 10.4063024520874 50.31733703613281 10.92599868774414 L 55.31037902832031 16.79082679748535 C 55.42330169677734 16.92357063293457 55.58875274658203 17.00007247924805 55.76290130615234 17.00007247924805 C 55.93705749511719 17.00007247924805 56.10250473022461 16.92360496520996 56.21543121337891 16.79082679748535 L 61.20707321166992 10.92759323120117 C 61.65804290771484 10.4049072265625 61.9936637878418 9.850911140441895 62.20330810546875 9.284663200378418 C 62.99526977539062 7.19056510925293 62.69707107543945 4.824600696563721 61.4056282043457 2.955788135528564 Z M 61.0901985168457 8.868359565734863 C 60.92852783203125 9.305248260498047 60.66459655761719 9.737189292907715 60.30617141723633 10.15266227722168 C 60.30517578125 10.15365791320801 60.30417633056641 10.15465450286865 60.30338287353516 10.15584945678711 L 55.76290130615234 15.48889255523682 L 51.21963119506836 10.15249729156494 C 50.86140441894531 9.73738956451416 50.59746932983398 9.30548095703125 50.4342041015625 8.864409446716309 C 49.78056716918945 7.135680675506592 50.02863311767578 5.179476737976074 51.09797668457031 3.631839990615845 C 52.17067337036133 2.079255342483521 53.87107849121094 1.188809871673584 55.76290130615234 1.188809871673584 C 57.65469360351562 1.188809871673584 59.35490036010742 2.079221963882446 60.42762756347656 3.631839990615845 C 61.49717330932617 5.179476737976074 61.74543380737305 7.135680675506592 61.0901985168457 8.868359565734863 Z">
							</path>
						</svg>
						<svg class="location_1_pc_event" viewBox="155.754 106.219 6.657 6.657">
							<path id="location_1_pc_event" d="M 159.0827178955078 106.218994140625 C 157.2473754882812 106.218994140625 155.7540283203125 107.712158203125 155.7540283203125 109.5476989746094 C 155.7540283203125 111.3832397460938 157.2471923828125 112.8763885498047 159.0827178955078 112.8763885498047 C 160.9182739257812 112.8763885498047 162.4114074707031 111.3832397460938 162.4114074707031 109.5476989746094 C 162.4114074707031 107.7123565673828 160.9180603027344 106.218994140625 159.0827178955078 106.218994140625 Z M 159.0827178955078 111.6875457763672 C 157.9028167724609 111.6875457763672 156.9428405761719 110.7275695800781 156.9428405761719 109.5476684570312 C 156.9428405761719 108.3677520751953 157.9028167724609 107.4077758789062 159.0827178955078 107.4077758789062 C 160.2626342773438 107.4077758789062 161.2225952148438 108.3677520751953 161.2225952148438 109.5476684570312 C 161.2225952148438 110.7275695800781 160.2626342773438 111.6875457763672 159.0827178955078 111.6875457763672 Z">
							</path>
						</svg>
					</div>
				</div>
				))}
			</div>
		</div>
		
		<div id="completed_events_grp_all_pc">
			<svg class="bg_of_completed_dz">
				<linearGradient id="bg_of_completed_dz" spreadMethod="pad" x1="1.3" x2="0.019" y1="1.397" y2="0">
					<stop offset="0" stop-color="#26a1ff" stop-opacity="1"></stop>
					<stop offset="1" stop-color="#fff" stop-opacity="1"></stop>
				</linearGradient>
				<rect id="bg_of_completed_dz" rx="20" ry="20" x="0" y="0" width="100%" height="561">
				</rect>
			</svg>
			<svg class="comple_line_new_events_page_pc" viewBox="0 0 5 26">
				<path id="comple_line_new_events_page_pc" d="M 0 0 L 0 26">
				</path>
			</svg>
			<div id="events_completed_new_events_pa">
				<span>Completed Events</span>
			</div>
			<div id="Scroll_completed_events">
			{events.filter(rec=>rec.organiserId===user._id).map((eve)=>(
				<div id="completed_vent_card_new_events">
					<svg class="overal_bg_event_new_pc">
						<rect id="overal_bg_event_new_pc" rx="10" ry="10" x="0" y="0" width="326.76" height="448">
						</rect>
					</svg>
					<div id="By_event_new_pc_d">
						<span>By</span>
					</div>
					<div id="Son_Goku_event_new_pc_d">
						<span>{eve.organiserName}</span>
					</div>
					<div id="Suzume_event_new_pc">
						<span>{eve.title}</span>
					</div>
					<img id="logo_event_new_pc_d" src={eve.organiserImageId?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.organiserImageId:"./MyPortfolio/Events/logo_event_new_pc_d.png"}  />
						
					<img id="img_event_new_pc" src={eve.eventImageUrl?process.env.REACT_APP_GOOGLEDRIVE_VIEW_IMG+eve.eventImageUrl.split('/')[5]:"./MyPortfolio/Events/img_event_new_pc.png"} />
						
					<svg class="shade_img_event_new_pc">
						<rect id="shade_img_event_new_pc" rx="8" ry="8" x="0" y="0" width="287" height="159">
						</rect>
					</svg>
					<div id="seats_rpohg_bar">
						<div id="Seats_lbl_event_new_pc">
							<span>Seats</span>
						</div>
						<div id="n_0_event_new_pc_ed">
							<span>50%</span>
						</div>
						<svg class="overall_b_ar_event_new_pc">
							<rect id="overall_b_ar_event_new_pc" rx="2" ry="2" x="0" y="0" width="256" height="4">
							</rect>
						</svg>
						<svg class="bar_event_new_pc">
							<rect id="bar_event_new_pc" rx="2" ry="2" x="0" y="0" width="130" height="4">
							</rect>
						</svg>
					</div>
					{/* <svg class="paid_bdr_event_new_pc">
						<rect id="paid_bdr_event_new_pc" rx="5" ry="5" x="0" y="0" width="55" height="31">
						</rect>
					</svg>
					<div id="Paid_lbl_event_new_pc_eh">
						<span>Paid</span>
					</div> */}
					<svg class="amount_bdr_event_new_pc_ei">
						<rect id="amount_bdr_event_new_pc_ei" rx="5" ry="5" x="0" y="0" width="73" height="31">
						</rect>
					</svg>
					<div id="n_1139_cost_event_new_pc">
						<span>{eve.cost}</span>
					</div>
					{/* <svg class="green_dot_new_events_page_pc">
						<ellipse id="green_dot_new_events_page_pc" rx="3.096630334854126" ry="3.096630334854126" cx="3.096630334854126" cy="3.096630334854126">
						</ellipse>
					</svg>
					<div id="Online_Event_new_events_page_p">
						<span>Online Event</span>
					</div> */}
					<svg class="share_bdr_new_events_page_pc">
						<ellipse id="share_bdr_new_events_page_pc" rx="19" ry="19" cx="19" cy="19">
						</ellipse>
					</svg>
					<img id="sharenew_events_page_pc" src="./MyPortfolio/Events/sharenew_events_page_pc.png" srcset="./MyPortfolio/Events/sharenew_events_page_pc.png 1x" />
						
					<svg class="bdr_trophie_hi">
						<rect id="bdr_trophie_hi" rx="5" ry="5" x="0" y="0" width="73" height="31">
						</rect>
					</svg>
					{/* <img id="trophy_img_event_new_pc_312" src="./MyPortfolio/Events/trophy_img_event_new_pc_312.png" srcset="./MyPortfolio/Events/trophy_img_event_new_pc_312.png 1x" />
						
					<div id="n_234_com_event_new_pc_pcpc">
						<span>1234</span>
					</div> */}

					<div id='trophy_img_event_new_pc_312'>
					<TrophiesAndCountMob portfolioType={"events"} portfolioId={eve._id} />
					</div>

					<div id="de_copketed_com_pc_event">
						<div id="From_lbl_pc_event_es">
							<span>From</span>
						</div>
						<div id="n_3th_Jan_2023__pc_event">
							<span>{eve.startsOn.slice(0,10)} - {eve.startsOn.slice(11,16)} IST</span>
						</div>
						<div id="To_lbl_pc_event_eu">
							<span>To</span>
						</div>
						<div id="n_4th_Jan_2023_pc_event">
							<span>{eve.endsOn.slice(0,10)} - {eve.endsOn.slice(11,16)} IST</span>
						</div>
						<svg class="calender_dot_3_com_pc_event">
							<ellipse id="calender_dot_3_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dot_2_com_pc_event">
							<ellipse id="calender_dot_2_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dot_1_com_pc_event">
							<ellipse id="calender_dot_1_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_9_com_pc_event">
							<ellipse id="calender_dor_9_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_8_com_pc_event">
							<ellipse id="calender_dor_8_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_7_com_pc_event">
							<ellipse id="calender_dor_7_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_outer_com_pc_event" viewBox="0 0 17 17">
							<path id="calender_outer_com_pc_event" d="M 16.3359375 11.6875 C 16.70269966125488 11.6875 17 11.39019870758057 17 11.0234375 L 17 3.984375238418579 C 17 2.519718647003174 15.80840587615967 1.328125 14.34375 1.328125 L 13.48046875 1.328125 L 13.48046875 0.6640625 C 13.48046875 0.297300785779953 13.18316745758057 0 12.81640625 0 C 12.44964504241943 0 12.15234375 0.297300785779953 12.15234375 0.6640625 L 12.15234375 1.328125 L 9.130859375 1.328125 L 9.130859375 0.6640625 C 9.130859375 0.297300785779953 8.833558082580566 0 8.466796875 0 C 8.100035667419434 0 7.802734851837158 0.297300785779953 7.802734851837158 0.6640625 L 7.802734851837158 1.328125 L 4.814453125 1.328125 L 4.814453125 0.6640625 C 4.814453125 0.297300785779953 4.517152309417725 0 4.150390625 0 C 3.783628702163696 0 3.486328125 0.297300785779953 3.486328125 0.6640625 L 3.486328125 1.328125 L 2.65625 1.328125 C 1.191593766212463 1.328125 0 2.519718647003174 0 3.984375238418579 L 0 14.34375 C 0 15.80840587615967 1.191593766212463 17 2.65625 17 L 14.34375 17 C 15.80840587615967 17 17 15.80840587615967 17 14.34375 C 17 13.97698879241943 16.70269966125488 13.6796875 16.3359375 13.6796875 C 15.96917629241943 13.6796875 15.67187595367432 13.97698879241943 15.67187595367432 14.34375 C 15.67187595367432 15.07607841491699 15.07607841491699 15.67187595367432 14.34375 15.67187595367432 L 2.65625 15.67187595367432 C 1.923921704292297 15.67187595367432 1.328125 15.07607841491699 1.328125 14.34375 L 1.328125 3.984375238418579 C 1.328125 3.252046585083008 1.923921704292297 2.65625 2.65625 2.65625 L 3.486328125 2.65625 L 3.486328125 3.3203125 C 3.486328125 3.687074184417725 3.783628702163696 3.984375238418579 4.150390625 3.984375238418579 C 4.517151832580566 3.984375238418579 4.814453125 3.687074184417725 4.814453125 3.3203125 L 4.814453125 2.65625 L 7.802734851837158 2.65625 L 7.802734851837158 3.3203125 C 7.802734851837158 3.687074184417725 8.100034713745117 3.984375238418579 8.466796875 3.984375238418579 C 8.833558082580566 3.984375238418579 9.130859375 3.687074184417725 9.130859375 3.3203125 L 9.130859375 2.65625 L 12.15234375 2.65625 L 12.15234375 3.3203125 C 12.15234375 3.687074184417725 12.44964504241943 3.984375238418579 12.81640625 3.984375238418579 C 13.18316745758057 3.984375238418579 13.48046875 3.687074184417725 13.48046875 3.3203125 L 13.48046875 2.65625 L 14.34375 2.65625 C 15.07607841491699 2.65625 15.67187595367432 3.252046585083008 15.67187595367432 3.984375238418579 L 15.67187595367432 11.0234375 C 15.67187595367432 11.39019870758057 15.96917629241943 11.6875 16.3359375 11.6875 Z">
							</path>
						</svg>
						<svg class="calender_dor_6_com_pc_event">
							<ellipse id="calender_dor_6_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_5_com_pc_event">
							<ellipse id="calender_dor_5_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_4_com_pc_event">
							<ellipse id="calender_dor_4_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_3_com_pc_event">
							<ellipse id="calender_dor_3_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_2_com_pc_event">
							<ellipse id="calender_dor_2_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<svg class="calender_dor_1_com_pc_event">
							<ellipse id="calender_dor_1_com_pc_event" rx="0.75" ry="0.75" cx="0.75" cy="0.75">
							</ellipse>
						</svg>
						<div id="Location_lbl_new_pc_event">
							<span>Location</span>
						</div>
						<div id="Online_Meet_-_up_new_pc_event">
							<span>{eve.location}</span>
						</div>
						<svg class="loca_2_pc_event" viewBox="48.886 0 13.754 17">
							<path id="loca_2_pc_event" d="M 61.4056282043457 2.955788135528564 C 60.10781478881836 1.077479243278503 58.05097198486328 0 55.76290130615234 0 C 53.47483062744141 0 51.41798782348633 1.077479243278503 50.12017440795898 2.955788135528564 C 48.82873153686523 4.824601173400879 48.53053283691406 7.190566539764404 49.32090377807617 9.280878067016602 C 49.53231048583984 9.851707458496094 49.86835861206055 10.4063024520874 50.31733703613281 10.92599868774414 L 55.31037902832031 16.79082679748535 C 55.42330169677734 16.92357063293457 55.58875274658203 17.00007247924805 55.76290130615234 17.00007247924805 C 55.93705749511719 17.00007247924805 56.10250473022461 16.92360496520996 56.21543121337891 16.79082679748535 L 61.20707321166992 10.92759323120117 C 61.65804290771484 10.4049072265625 61.9936637878418 9.850911140441895 62.20330810546875 9.284663200378418 C 62.99526977539062 7.19056510925293 62.69707107543945 4.824600696563721 61.4056282043457 2.955788135528564 Z M 61.0901985168457 8.868359565734863 C 60.92852783203125 9.305248260498047 60.66459655761719 9.737189292907715 60.30617141723633 10.15266227722168 C 60.30517578125 10.15365791320801 60.30417633056641 10.15465450286865 60.30338287353516 10.15584945678711 L 55.76290130615234 15.48889255523682 L 51.21963119506836 10.15249729156494 C 50.86140441894531 9.73738956451416 50.59746932983398 9.30548095703125 50.4342041015625 8.864409446716309 C 49.78056716918945 7.135680675506592 50.02863311767578 5.179476737976074 51.09797668457031 3.631839990615845 C 52.17067337036133 2.079255342483521 53.87107849121094 1.188809871673584 55.76290130615234 1.188809871673584 C 57.65469360351562 1.188809871673584 59.35490036010742 2.079221963882446 60.42762756347656 3.631839990615845 C 61.49717330932617 5.179476737976074 61.74543380737305 7.135680675506592 61.0901985168457 8.868359565734863 Z">
							</path>
						</svg>
						<svg class="loca_1_new_pc_event" viewBox="155.754 106.219 6.657 6.657">
							<path id="loca_1_new_pc_event" d="M 159.0827178955078 106.218994140625 C 157.2473754882812 106.218994140625 155.7540283203125 107.712158203125 155.7540283203125 109.5476989746094 C 155.7540283203125 111.3832397460938 157.2471923828125 112.8763885498047 159.0827178955078 112.8763885498047 C 160.9182739257812 112.8763885498047 162.4114074707031 111.3832397460938 162.4114074707031 109.5476989746094 C 162.4114074707031 107.7123565673828 160.9180603027344 106.218994140625 159.0827178955078 106.218994140625 Z M 159.0827178955078 111.6875457763672 C 157.9028167724609 111.6875457763672 156.9428405761719 110.7275695800781 156.9428405761719 109.5476684570312 C 156.9428405761719 108.3677520751953 157.9028167724609 107.4077758789062 159.0827178955078 107.4077758789062 C 160.2626342773438 107.4077758789062 161.2225952148438 108.3677520751953 161.2225952148438 109.5476684570312 C 161.2225952148438 110.7275695800781 160.2626342773438 111.6875457763672 159.0827178955078 111.6875457763672 Z">
							</path>
						</svg>
					</div>
				</div>
				))}
			</div>
		</div>
		
	</div>
	{openEvents=== true ?<EventsPopUI  openEvents={openEvents} closeEvents={()=>{setOpenEvents(false);getEvents()}}/>:""}
    </div>
  )
}

export default MyEventsUI
